import { LayerSwitcherControl } from '../controls/LayerSwitcherControl';
import { UnitsAndZoomControl } from '../controls/UnitsAndZoomControl';

export class Controls {
    static unitsAndZoomControl = (maps, defaultMap) => {
        return new UnitsAndZoomControl({
            basemaps: maps,
            initialBasemap: defaultMap.style,
        });
    };

    static layerSwitcherControl = (maps, defaultMap) => {
        return new LayerSwitcherControl({
            basemaps: maps,
            initialBasemap: defaultMap.style,
        });
    };
}
